import PropTypes from 'prop-types';
import './menuDivider.css';

/*
#tailwind
*/

function MenuDivider({ children, ...other }) {
  return <div className="menuDivider" {...other} />;
}

MenuDivider.propTypes = {
  children: PropTypes.node,
};

MenuDivider.defaultProps = {
  children: undefined,
};

export default MenuDivider;
